import { computed } from "vue";
export function useShadowable(props) {
  const shadowableString = computed(() => {
    if (props.flat || props.shadow === false) {
      return null;
    }
    if (props.shadowSmall) {
      return "sm";
    }
    if (props.shadowMedium) {
      return "md";
    }
    if (props.shadowLarge) {
      return "lg";
    }
    return [true, "true", ""].indexOf(props.shadow) > -1 ? "sm" : props.shadow;
  });
  return {
    shadowableString
  };
}
